const mutations = {
  type: 'SET_TYPE',
  data: 'SET_DATA'
}

export const addItem = ({ commit }) => {
  return new Promise((resolve) => {
    commit('ADD')
    resolve()
  })
}

export const removeItem = ({ commit }, key) => {
  return new Promise((resolve) => {
    commit('DELETE', key)
    resolve()
  })
}

/**
 * Update Delivery Note
 * @param {Object} payload - Delivery Object.
 */
export const updateItem = ({ commit }, payload) => {
  return new Promise((resolve) => {
    let key = payload.key
    Object().keys(payload).filter(k => k !== 'key')
    .forEach(param => {
      commit(mutations[param], { key, param, value: payload[param] })
    })
    resolve()
  })
}

export const empty = ({ commit, dispatch, state }) => {
  return new Promise((resolve) => {
    if (!state.list.length) resolve()
    Promise.all([
      state.list.map((key) => {
        return dispatch('removeItem', key)
      })
    ]).then(() => {
      resolve()
    })
  })
}
